import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import auth from "../modules/auth/reducer";
import profile from "../modules/profile/reducer";
import properties from "../modules/brands/reducer";
import mortgage from "../modules/mortgage/reducer";
import reservation from "../modules/reservation/reducer";
import dashboard from "../modules/dashboard/reducer";
import resources from "../modules/resources/reducer";
import cmsHoc from "../commons/ProjectCMSHOC/reducer";
import theme from "../commons/ThemeManager/reducer";
import maintainedValues from "../commons/MaintainedValues/reducer";
import marketingPartners from "../modules/dashboard/pages/marketing/reducer";
import ebooking from '../modules/dashboard/pages/e-booking/reducer';

const authPersistConfig = {
  key: "rlspauth",
  storage
};
const dashboardPersistConfig = {
  key: "dashboard",
  storage,
  blacklist: [
    "buyerResult",
    "spouseResult",
    "coBuyerResult",
    "leadProfile",
    "leadDataResult"
  ]
};

export default combineReducers({
  auth: persistReducer(authPersistConfig, auth),
  profile,
  properties,
  mortgage,
  reservation,
  dashboard: persistReducer(dashboardPersistConfig, dashboard),
  resources,
  cmsHoc,
  theme,
  maintainedValues,
  marketingPartners,
  ebooking
});
